import { LayerOrientation } from "@buildwithflux/models";
import { radiansToDegrees } from "@buildwithflux/shared";
import { fixAngleDecimals, getModule, toMm } from "./support/utils";
function transformTextContent(content) {
    let transformed = content;
    transformed = transformed.trim();
    // There are large font differences between our TTF font displayed in the app and the vector-based font used in KiCad
    // Until we find a better way to remove the differences, this replaces some glyphs with ones that render more closely in appearance, in the NewStroke font that KiCad uses
    transformed = transformed
        // Replace ordinary spaces with a narrower unicode space (four per em)
        .replace(/ /g, "\u2005")
        // Replace ordinary hyphen-dashes (the normal ASCII hyphen) with narrower unambiguous unicode hyphens
        .replace(/-/g, "\u2010");
    // Escape backslashes
    transformed = transformed.replace(/\\/g, "\\\\");
    return transformed;
}
export const mapText = (text, context, postprocess) => {
    const br = text.bakedRules;
    if (!br) {
        return null;
    }
    const textContent = transformTextContent(br.content);
    if (!textContent) {
        // No use in exporting empty text
        return null;
    }
    // Somehow, a user was able to get their project into a state where fontSize was undefined. This led
    // to a runtime crash. The issue in question was FLUX-7907
    const fontSize = br.fontSize ?? 0;
    if (fontSize <= 0) {
        return null;
    }
    const scale = br.scale.x;
    const at = {
        x: toMm(br.positionRelativeToDocument.x),
        y: -toMm(br.positionRelativeToDocument.y),
        unlocked: true,
        angle: fixAngleDecimals(radiansToDegrees(br.rotationRelativeToDocument.z)),
    };
    const justify = [];
    if (br.textAlign !== "center") {
        // <center> is the default/implied alignment
        justify.push(br.textAlign);
    }
    if (br.layer === LayerOrientation.bottom) {
        justify.push("mirror");
        at.angle = (-at.angle + 180) % 360;
    }
    postprocess((mapped) => {
        if (!mapped)
            return;
        const module = getModule(br.layer, context);
        module.fp_text = module.fp_text ?? [];
        module.fp_text.push(mapped);
    });
    return {
        text: textContent,
        type: "user",
        at,
        layer: br.layer === LayerOrientation.top ? "F.SilkS" : "B.SilkS",
        effects: {
            font: {
                // The co-efficients here were chosen so that the overall size of an fp_text feature matches
                // as closely as we can get to the Roboto rendering in the app. They're chosen by trial and error.
                size: {
                    width: toMm(fontSize * 0.8 * scale),
                    height: toMm(fontSize * 0.8 * scale),
                },
                thickness: toMm(fontSize * 0.095 * scale),
            },
            justify,
        },
    };
};
//# sourceMappingURL=mapText.js.map